/** Une clases condicionalmente sin dependencias externas. */
export function cn(...values) {
  return values
    .flat(3)
    .filter((value) => typeof value === 'string' && value.trim() !== '')
    .join(' ')
}
